import React, { useState, useEffect, useMemo } from 'react';
import Constant from '@/common/constant/Constant';
import Utils, { isDisableApproveRejectAnonymousQaTicket } from '@/common/utils/utils';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { formatUserDateTime } from '@/common/utils/timezoneUtils';
import { userAtom } from '@/state/atom/userAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { projectInuseDetailAtom, projectListInCorporationByUserIdAtom } from '@/state/atom/projectAtom';
import {
    getDetailTicketInList,
    getCurrentTelephoneStatusData,
    onClickApproveAnonymousQaTicket,
    onClickRejectAnonymousQaTicket,
    onSubmitApproveAnonymousQaFromLiveChat
} from './handler/TicketListHandler';
import { generateDetatilTicketTitle, isDisableApproveRejectAnonymousQaFromLiveChat, isDisableCallBackButton, getTelephoneTicketIcon } from './handler/TicketHandler';
import { Button, Tooltip, Typography, IconButton } from '@material-ui/core';
import AttachThumbnailList from '@/component/common/AttachFileThumbnail/components/AttachThumbnailList';
import DetailTicketListLastMessage from './DetailTicketListLastMessage';
import useListTicketOnDemandDisplay from '@/component/multiLanguage/hooks/useListTicketOnDemandDisplay';
import DetailTicketListAssignee from './DetailTicketListAssignee';
import DetailTicketListStatus from './DetailTicketListStatus';
import {
    closePanelTabSelector,
    setPanelSelector,
    triggerReloadTicketListByPanelType
} from '@/state/selector/panelSelector';
import { multiPanelAtom } from '@/state/atom/panelAtom';
import { checkDetailTicket } from '@/service/ticketService';
import DetailTicketListSkeleton from './DetailTicketListSkeleton';
import { getTicketStorageData, isQaAnonymousFromIframeOrChatBotApprovedAndCusInviteSettingOff } from './handler/DetailTicketListHandler';
import SDeskTooltip from '../common/SDeskTooltip';
import { handleDeleteCompleteTicketLiveChat, renderUserName, isDisplayIconChat } from '../chatThread/handler/DetailTicketHandler';
import { useSnackbar } from 'notistack';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { helpdeskTicketLastUserActionAtom } from '@/state/atom/ticketAtom';
import LogKibanaConstant from '@/common/constant/LogKibanaConstant';
import localStorageUtil from '@/common/utils/localStorageUtil';
import {showLoadingMouse, hideLoadingMouse} from '@/common/utils/CustomCursor';
import Bookmark from '../ticketKnowledge/elements/Bookmark/Bookmark';
import TaggedBookmarkListName from '../ticketKnowledge/elements/Bookmark/TaggedBookmarkListName';
import TelephoneConstant from '@/common/constant/TelephoneConstant';
import { useOutboundCall } from '@/hooks/useOutboundCall';
import { validateTelephonePermission } from '@/service/phoneContactService';
import DataChangePleaseReloadModal from '@/component/common/modal/DataChangePleaseReloadModal';
import { handleOpenPanelTelephoneRetryOrFollowUp } from '@/component/telephoneAgent/handler/TelephoneTicketPanelHandler';
import { voiceStatusAtom } from '@/state/atom/voiceCallAtom';
import CopyShareLinkListItem from '@/component/common/CopyShareLinkListItem';
import { resolveVoiceCallTarget, resolveVoiceCallTargetName } from './handler/TelephoneVoiceCallHandler';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { translateFixedNameText } from '@/common/utils/translationUtils';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import { isDisplayTicketThumbnail } from '../common/AttachFileThumbnail/handler/attachThumbnailHandler';

let MAX_LENGTH_DISPLAY_TEXT = 50;

export default function DetailTicketList(props) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const {
        API,
        ticket,
        ticketListType,
        isHelpdeskListTicket,
        isCustomerListTicket,
        selectedTicket,
        setSelectedTicket,
        setConfirmForceEditTicket,
        setIsOpenModalReloadPage,
        setIsConfirmAcceptTicket,
        setIsConfirmRejectTicket,
        setIsLoading,
        setTriggerSearch,
        projectUserList,
        panelId,
        ticketList,
        setTicketList,
        panelType,
        tabId,
        componentName,
        history,
        triggerSearch,
        viewStructure
    } = props;
    const ticketId = ticket.id;

    // common userDetail state
    const userDetail = useRecoilValue(userAtom);
    // common projectInuse state
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const projectList = useRecoilValue(projectListInCorporationByUserIdAtom);
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);

    // State
    const [ticketDetail, setTicketDetail] = useState({});
    const [ticketAffiliationProject, setTicketAffiliationProject] = useState('');
    const [titleDisplay, setTitleDisplay] = useState('');

    // On-demand list translation (MLT-001-F4): resolve the title to display from the
    // original computed below. Last message is handled in DetailTicketListLastMessage,
    // so only the title is resolved here.
    const originalTicketTitle = Utils.getTitle(ticketDetail?.settingTitle)
        ? generateDetatilTicketTitle(ticketDetail)
        : tr('[概要 (現在未記入)]');
    const { displayTitle: onDemandTicketTitle } = useListTicketOnDemandDisplay(
        originalTicketTitle,
        null,
        { panelType, viewKey: props.viewSelectedId, ticketId }
    );
    const [isDeletedCorporationOrigin, setIsDeletedCorporationOrigin] = useState(false);
    const [isLoadingDetail, setIsLoadingDetail] = useState(false);
    // const [isOpenPopupTicketError, setIsOpenPopupTicketError] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [corporationDetail, setCorporationDetail] = useRecoilState(corporationAtom);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [isShowDialogDeleteTicketFromLiveChat, setIsShowDialogDeleteTicketFromLiveChat] = useState(false);
    const [projectDetails, setProjectDetails] = useState(projectInuseDetail);
    const setLastUserAction = useSetRecoilState(helpdeskTicketLastUserActionAtom);
    const currentProjectId = localStorageUtil.getSelectedProjectId();
    const [isShowAffiliationProjectTypeTooltip, setIsShowAffiliationProjectTypeTooltip] = useState(false);
    const [isViewDelete, setIsViewDelete] = useState(false);
    const isAnonymousTicket = useMemo(() => {
        return (
            isHelpdeskListTicket &&
            (Utils.isAnonymousQAWaitingOrEndLiveChatTicket(ticketDetail) ||
                Utils.isAnonymousQAWaitingTicket(ticketDetail))
        );
    }, [isHelpdeskListTicket, ticketDetail]);
    const [showTelephonePermissionError, setShowTelephonePermissionError] = useState(false);
    const [telephoneErrorContent, setTelephoneErrorContent] = useState('');
    const isLiveTicket = ticketDetail.liveOrArchived === Constant.LIVE_OR_ARCHIVED.LIVE;

     // useOutboundCall hook cho callback button
     const { initiateCall } = useOutboundCall();
     const voiceStatus = useRecoilValue(voiceStatusAtom);

    useEffect(() => {
        const controller = new AbortController();
        setIsLoadingDetail(true);

        getDetailTicketInList(
            API,
            [{
                ticketId: ticket.id,
                affiliationOrganization: ticket?.affiliationOrganization
            }],
            ticketListType,
            corporationDetail.id,
            projectInuseDetail.id,
            userDetail.id,
        )
            .then(async ticketDetailListResponse => {
                if (Utils.isEmptyArray(ticketDetailListResponse)) {
                    updateAfterGetTicketDetailFail();
                    return;
                }

                let ticketDetailResponse = ticketDetailListResponse.find(ticketChild => ticketChild.id === ticketId);
                if (Utils.isEmptyObject(ticketDetailResponse)) {
                    updateAfterGetTicketDetailFail();
                    return;
                }
                ticketDetailResponse.dataShareLink = Utils.convertJSONDataToObject(ticketDetailResponse?.dataShareLink);
                ticketDetailResponse.attachFiles = Utils.convertJSONDataToObject(ticketDetailResponse?.attachFiles);

                // Ticket detail
                let ticketDetailFormatResponse = await getTicketStorageData(ticketDetailResponse);
                setTicketDetail(ticketDetailFormatResponse);

                // Set ticketAffiliationProject
                let ticketAffiliationProjectName = '';
                if (
                    isHelpdeskListTicket &&
                    (Utils.isAnonymousQAWaitingTicket(ticketDetailFormatResponse) || Utils.isAnonymousQARejectTicket(ticketDetailFormatResponse) || Utils.isAnonymousQATicketFromLiveChat(ticketDetailFormatResponse))
                ) {
                      ticketAffiliationProjectName = `${
                          ticketDetailFormatResponse.anonymousUserInfo?.lastName
                              ? ticketDetailFormatResponse.anonymousUserInfo?.lastName
                              : ''
                      } ${
                          ticketDetailFormatResponse.anonymousUserInfo?.firstName
                              ? ticketDetailFormatResponse.anonymousUserInfo?.firstName
                              : ''
                      }${tr('（未登録カスタマー）')}`;
                  } else if (ticketDetailFormatResponse?.affiliationProjectInfo?.name) {
                    ticketAffiliationProjectName =
                        ticketDetailFormatResponse?.affiliationProjectInfo?.name;
                        
                    if (isQaAnonymousFromIframeOrChatBotApprovedAndCusInviteSettingOff(projectInuseDetail, ticketDetailFormatResponse)) {
                        ticketAffiliationProjectName = getTicketAffiliationProjectName(ticketDetailFormatResponse);
                    }
                }
                if (ticketDetailFormatResponse.ticketType === Constant.TICKET_TYPE.TASK) {
                    if (ticketDetailFormatResponse?.creator && ticketDetailFormatResponse?.creatorInfo?.fullName) {
                        ticketAffiliationProjectName = `${ticketDetailFormatResponse?.creatorInfo?.fullName}`;
                    } else {
                        ticketAffiliationProjectName = '';
                    }
                }

                if (ticketDetailFormatResponse.ticketType === Constant.TICKET_TYPE.EMAIL) {
                    // Send from Sdesk
                    let toListOfEmailTicket = ticketDetailFormatResponse.toListOfEmailTicket;
                    if (toListOfEmailTicket) {
                        toListOfEmailTicket = Utils.convertJSONDataToObject(ticketDetailFormatResponse.toListOfEmailTicket);
                        if (!Utils.isEmptyArray(toListOfEmailTicket?.toList)) {
                            setIsShowAffiliationProjectTypeTooltip(true);
                            // Value display in ticket list
                            ticketAffiliationProjectName = `${toListOfEmailTicket?.firstTo} ${tr('、他')}`;
                            if (toListOfEmailTicket?.firstTo && toListOfEmailTicket?.firstTo.length > MAX_LENGTH_DISPLAY_TEXT) {
                                ticketAffiliationProjectName = `${toListOfEmailTicket?.firstTo.substring(0, MAX_LENGTH_DISPLAY_TEXT)}... ${tr('、他')}`;
                            }

                            // value in tooltip
                            let moreToList = toListOfEmailTicket?.toList.join('\n');
                            if (toListOfEmailTicket?.firstTo) {
                                moreToList = `${toListOfEmailTicket?.firstTo} \n ${moreToList}`
                            }
                            setTitleDisplay(moreToList);
                        } else {
                            ticketAffiliationProjectName = toListOfEmailTicket?.firstTo;
                        }
                    }
                }

                if (ticketDetailFormatResponse.ticketType === Constant.TICKET_TYPE.TELEPHONE) {
                    if (ticketDetailFormatResponse?.affiliationProjectInfo?.name) {
                        ticketAffiliationProjectName = ticketDetailFormatResponse?.affiliationProjectInfo?.name;
                    }
                }

                setTicketAffiliationProject(ticketAffiliationProjectName);
                
                // Set isDeletedCorporationOriginStatus
                let isDeletedCorporationOriginStatus = false;
                if (
                    ticketDetailFormatResponse.affiliationProjectInfo?.corporationInfo?.active ===
                    Constant.CORPORATION_ACTIVE.DELETED
                ) {
                    isDeletedCorporationOriginStatus = true;
                }
                setIsDeletedCorporationOrigin(isDeletedCorporationOriginStatus);
                setIsLoadingDetail(false);
            })
            .catch(error => {
                updateAfterGetTicketDetailFail();
            });

            return () => {
                controller.abort();
                setProjectDetails({});
                setIsLoadingDetail(false);
                setTicketDetail({});
                setTicketAffiliationProject('');
                setIsDeletedCorporationOrigin(false);
            }
    }, [ticket.id, ticket.updatedAt, triggerSearch, props?.triggerReload]);

    const getTicketAffiliationProjectName = (ticketData) => {
        let anonymousUserInfo = ticketData.anonymousUserInfo;
        let userName = renderUserName(ticketData)
        return `${anonymousUserInfo.mailAddress} ${userName}`;        
    }

    const getPanelType = () => {
        let currentPanelIndex = Utils.findIndexInArrayById(panelId, panelList);
        if (currentPanelIndex === -1) return '';
        let currentPanel = panelList[currentPanelIndex];
        return currentPanel.type;
    };

    const getTicketListType = () => {
        return getPanelType() === Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
            ? Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
            : Constant.PANEL_TYPE.HELPDESK_TICKET_LIST;
    };

    const openTicketDetailPanel = async () => {
        showLoadingMouse();
        let openDetailPanelProps = {
            API: API,
            panelId: panelId,
            tabId: tabId,
            ticketId: ticketId,
            componentName: componentName,
            ticketListType: ticketListType,
            panelType: panelType,
            history: history,
        }
        setIsLoading(true);
        let {status: currentStatusTicket} = await checkDetailTicket(API, ticketDetail.id);
        setIsLoading(false);
        if (currentStatusTicket === Constant.TICKET_DELETED_STATUS.REMOVED) {
            reloadTicketListByPanelType({
                panelType: getTicketListType()
                    ? getTicketListType()
                    : Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST
            });
            hideLoadingMouse();
            return;
        }

        let newPanelTicketDetailId = Date.now().toString();
        let isTicketDeleted = Utils.isEmptyString(ticketDetail?.deletedAt) ? false : true;
        if (ticketListType.includes('helpdesk')) {
            let helpdeskTicketDetailPanel = panelList.find(
                p => p.type === Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL
            );
            if (!Utils.isEmptyObject(helpdeskTicketDetailPanel)) {
                newPanelTicketDetailId = helpdeskTicketDetailPanel.id;
            }
        } else {
            let customerTicketDetailPanel = panelList.find(
                p => p.type === Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL
            );
            if (!Utils.isEmptyObject(customerTicketDetailPanel)) {
                newPanelTicketDetailId = customerTicketDetailPanel.id;
            }
        }
        setLastUserAction(LogKibanaConstant.CONTENT_OPERATION_ACTION.VIEW);

        const title = Utils.getTitle(ticketDetail.settingTitle);
        let isDraft = ticketDetail.public === Constant.TICKET_PUBLIC.DRAFT;
        let panelTicketType = ticketListType.includes('helpdesk') ? Constant.PANEL_TYPE.HELPDESK_TICKET_DETAIL : Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL;

        // namnh_emailTicket
        addNewPanel({
            //update
            type: panelTicketType,
            tabId: ticketDetail.id,
            props: openDetailPanelProps,
            ticketId: ticketDetail.id,
            ticketOutline: title,
            isDraft: isDraft,
            isEmailTicket: ticketDetail.ticketType === Constant.TICKET_TYPE.EMAIL,
            isTicketDeleted: isTicketDeleted,
            newPanelId: newPanelTicketDetailId,
            // isOpenChat: true,
            startRelatePanelFromPanelId: openDetailPanelProps.panelId
        });


        // check open chat
        let viewFromProjectOfEscalateTicket = false;
        if (currentProjectId !== ticketDetail.projectOrigin 
            && currentProjectId !== ticketDetail.affiliationProject 
            && !ticketDetail.projectTarget.includes(currentProjectId) 
            && ticketDetail.ticketType !== Constant.TICKET_TYPE.TASK) {
                viewFromProjectOfEscalateTicket = true;
        }

        // Telephone tickets viewed from a customer project should not be treated as
        // escalated, since they are always associated with the customer project directly.
        if (
            ticketDetail.ticketType === Constant.TICKET_TYPE.TELEPHONE && 
            projectInuseDetail.type === Constant.PROJECT_TYPE.CUSTOMER
        ) {
            viewFromProjectOfEscalateTicket = false;
        }

        let arg = {
            detailTicket: ticketDetail,
            isAnonymousQAWaitingTicket: Utils.isAnonymousQAWaitingTicket(ticketDetail),
            viewFromProjectOfEscalateTicket: viewFromProjectOfEscalateTicket
        }

        let isOpenChat = isDisplayIconChat(arg);
        if (!isOpenChat) {
            hideLoadingMouse();
            return;
        }
        
        let chatThreadPanelType = ticketListType.includes('helpdesk') ?  Constant.PANEL_TYPE.HELPDESK_CHATTHREAD : Constant.PANEL_TYPE.CUSTOMER_CHATTHREAD
        setTimeout(() => {
            let propsClone = {
                API: API,
                tabId: tabId,
                ticketId: ticketId,
                panelType: panelType,
            }

            addNewPanel({
                type: chatThreadPanelType,
                tabId: ticketDetail.id,
                currentPanelId: newPanelTicketDetailId,
                isTicketDeleted: !Utils.isEmptyString(ticketDetail?.deletedAt) ? true : false,
                isShowAllChatPost: false,
                props: propsClone,
                ticketOutline: title,
                ticketId,
                openRelatePanelType: panelTicketType,
                isEmailTicket: ticketDetail.ticketType === Constant.TICKET_TYPE.EMAIL
            });


            setTimeout(() => {
                hideLoadingMouse();
            }, 2000);

        }, 2000);

    };

    const updateAfterGetTicketDetailFail = () => {
        setIsLoadingDetail(false);
        setTicketDetail({});
    }

    useEffect(() => {
        let ticketProperty = Constant.TICKET_PROPERTY.SENT;
        const structure = Utils.convertJSONDataToObject(viewStructure);
        if (!Utils.isEmptyObject(structure)) {
            ticketProperty = structure?.ticketProperty;
        }

        const isDeleteOrArchiveView = [Constant.TICKET_PROPERTY.DELETE].includes(ticketProperty);
        setIsViewDelete(isDeleteOrArchiveView);
    }, [viewStructure]);

    const isQAPanel = useMemo(() => {
        return [
            Constant.PANEL_TYPE.CUSTOMER_TICKET_LIST,
            Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL
        ].includes(panelType);
    }, [panelType]);

    if (Utils.isEmptyObject(ticketDetail) || isLoadingDetail) {
        return (<DetailTicketListSkeleton />)
    }

    const params = {
        panelList: panelList,
        setPanelList: setPanelList,
        triggerReload: setTriggerSearch,
        API: API,
        userDetail,
        setIsLoading,
        selectedTicket: ticketDetail,
        corporationId: corporationDetail.id,
        currentProjectId: projectInuseDetail?.id,
        setIsOpenModalReloadPage,
        projectDetails,
        corporationDetail
    }

    const renderButtonAnonymous = () => {
        if (ticketDetail.anonymousUserInfo?.type === Constant.ANONYMOUS_TYPE.CHATBOT_LIVECHAT) {
            return (<>
                {!ticketDetail.deletedAt && (<div className="approve-reject-anonymous">
                    <Button
                        variant="contained"
                        className="btn-hg20 btn-outline-primary approve-anonymous"
                        color="primary"
                        disabled={isDisableApproveRejectAnonymousQaFromLiveChat(
                            ticketDetail,
                            projectInuseDetail,
                            corporationDetail,
                            true
                        )}
                        onClick={e =>
                            onSubmitApproveAnonymousQaFromLiveChat(
                                params,
                                reloadTicketListByPanelType
                            )
                        }
                    >
                        {trI18n('CBOTBT005')}
                    </Button>
                    <Button
                        variant="contained"
                        className="btn-hg20 btn-outline-light reject-anonymous"
                        color="primary"
                        disabled={isDisableApproveRejectAnonymousQaFromLiveChat(
                            ticketDetail,
                            projectInuseDetail,
                            corporationDetail,
                            false
                        )}
                        onClick={e =>
                            onClickRejectAnonymousQaTicket(
                                ticketDetail,
                                setSelectedTicket,
                                setIsConfirmRejectTicket
                            )
                        }
                    >
                        {trI18n('USER04BTN055')}
                    </Button>
                </div>)}
            </>);
        }
        return (
            <div className="approve-reject-anonymous">
                <Button
                    variant="contained"
                    className="btn-hg20 btn-outline-primary approve-anonymous"
                    color="primary"
                    disabled={isDisableApproveRejectAnonymousQaTicket(ticketDetail)}
                    onClick={e =>
                        onClickApproveAnonymousQaTicket(
                            ticketDetail,
                            setSelectedTicket,
                            setIsConfirmAcceptTicket
                        )
                    }
                >
                    {trI18n('USER04BTN054')}
                </Button>
                <Button
                    variant="contained"
                    className="btn-hg20 btn-outline-light reject-anonymous"
                    color="primary"
                    disabled={isDisableApproveRejectAnonymousQaTicket(ticketDetail)}
                    onClick={e =>
                        onClickRejectAnonymousQaTicket(
                            ticketDetail,
                            setSelectedTicket,
                            setIsConfirmRejectTicket
                        )
                    }
                >
                    {trI18n('USER04BTN055')}
                </Button>
            </div>
        );
    };

    const isShowLastMessage = () => {
        return (
            !Utils.isEmpty(ticketDetail.lastMessageInfo) &&
            ticketDetail.lastMessageInfo &&
            ticketDetail.lastMessageInfo.message &&
            ticketDetail.liveOrArchived !== Constant.LIVE_OR_ARCHIVED.DRAFT
        );
    };

    const renderTicketAffiliationProject = () => {
        // Translate only the fixed text (e.g. 組織内個人問い合わせ) at render time; names stay as-is
        const ticketAffiliationProjectDisplay = translateFixedNameText(ticketAffiliationProject);

        if (!isShowAffiliationProjectTypeTooltip) {
            return (
                <SDeskTooltip
                    value={`${ticketAffiliationProjectDisplay}`}
                />
            )
        }

        return (
            <SDeskTooltip
                value={`${ticketAffiliationProjectDisplay} `}
                toolTipValue={`${titleDisplay}`}
                tooltipAlign="left"
            />
        )
    }

    const getTelephoneCallStatus = () => {
        if (ticketDetail.ticketType !== Constant.TICKET_TYPE.TELEPHONE) {
            return null;
        }
        const currentTelephoneStatusData = getCurrentTelephoneStatusData(ticketDetail);
        return (
            currentTelephoneStatusData?.currentStatusField ||
            TelephoneConstant.TELEPHONE_CALL_STATUS.END_CALL
        );
    }

    const isTicketTask = ticketDetail.ticketType === Constant.TICKET_TYPE.TASK;
    const isEmailTicket = ticketDetail.ticketType === Constant.TICKET_TYPE.EMAIL;
    
    // Telephone ticket checks
    const isTelephoneTicket = ticketDetail.ticketType === Constant.TICKET_TYPE.TELEPHONE;

    const isGeneralTicket = !isTicketTask && !isEmailTicket && !isTelephoneTicket;

    // Check status ticket
    const telephoneCallStatus = getTelephoneCallStatus();

    const metaData = Utils.convertJSONDataToObject(ticketDetail?.metaData);
    const callDirection = metaData?.callDirection;
    const callType = metaData?.callType || '';
    const isVoiceCallTicket = callType === TelephoneConstant.CALL_TYPE.VOICE_CALL;

    // Check if callback button should be displayed
    // INBOUND: END_CALL, MISSING_CALL or CANCELLED_CALL
    // OUTBOUND: END_CALL, MISSING_CALL or CANCELLED_CALL
    const isInboundCallbackable = 
        callDirection === TelephoneConstant.CALL_DIRECTION.INBOUND && 
        (telephoneCallStatus === TelephoneConstant.TELEPHONE_CALL_STATUS?.END_CALL || 
         telephoneCallStatus === TelephoneConstant.TELEPHONE_CALL_STATUS?.MISSING_CALL ||
         telephoneCallStatus === TelephoneConstant.TELEPHONE_CALL_STATUS?.CANCELLED_CALL);
    
    const isOutboundCallbackable = 
        callDirection === TelephoneConstant.CALL_DIRECTION.OUTBOUND && 
        [
            TelephoneConstant.TELEPHONE_CALL_STATUS?.MISSING_CALL, 
            TelephoneConstant.TELEPHONE_CALL_STATUS?.END_CALL,
            TelephoneConstant.TELEPHONE_CALL_STATUS?.CANCELLED_CALL
        ].includes(telephoneCallStatus);

    const hasTelephonePermission = Utils.isEnableSettingTelephoneAgent(corporationDetail);
    const isPhoneRetryAllowedByProject =
        Utils.isPublicDesk(projectInuseDetail) &&
        Utils.isProjectOnExternalPhoneCall(projectInuseDetail);
    const isRetryAllowedByCallType = isVoiceCallTicket
        ? hasTelephonePermission
        : (hasTelephonePermission && isPhoneRetryAllowedByProject);
    const canShowCallbackByPanel = !isCustomerListTicket || isVoiceCallTicket;

    const shouldShowCallBackButton =
        isTelephoneTicket &&
        isLiveTicket &&
        (isInboundCallbackable || isOutboundCallbackable) &&
        isRetryAllowedByCallType &&
        canShowCallbackByPanel &&
        metaData?.telephoneType !== Constant.TICKET_PROPERTY.TRAINING &&
        metaData?.telephoneType !== TelephoneConstant.METADATA_TELEPHONE_TYPE.APP_INTEGRATION;

    // Handler function for call-back
    const handleCallBackCustomer = async (event, ticketData) => {
        event.stopPropagation();  // Prevent opening ticket detail
        try {
            let callTarget = '';
            if (isVoiceCallTicket) {
                callTarget = resolveVoiceCallTarget(metaData, ticketData, projectInuseDetail.id);
            } else {
                switch (callDirection) {
                    case TelephoneConstant.CALL_DIRECTION.INBOUND:
                        callTarget = metaData?.from;
                        break;
                    case TelephoneConstant.CALL_DIRECTION.OUTBOUND:
                        callTarget = metaData?.to;
                    break;
                    default:
                        break;
                }
            }
            if (!callTarget || Utils.isEmptyString(callTarget)) {
                return;
            }

            if (!isVoiceCallTicket) {
                // Validate telephone agent permission before making phone call retry.
                const validationResult = await validateTelephonePermission(
                    corporationDetail.id,
                    projectInuseDetail.id
                );
                if (!validationResult.isValid) {
                    setShowTelephonePermissionError(true);
                    return;
                }
            }

            // Check if ticket still exists (not deleted/archived by another user)
            const {status: ticketStatus, currentTicketDetail} = await checkDetailTicket(API, ticketData.id);
            if (ticketStatus !== Constant.TICKET_DELETED_STATUS.INUSED) {
                if (ticketStatus === Constant.TICKET_DELETED_STATUS.ARCHIVED) {
                    setTelephoneErrorContent(trI18n('MSG-CM-CHANGED-DATA'));
                } else {
                    setTelephoneErrorContent(trI18n('MSG-CM-DELETED-TICKET'));
                }
                setShowTelephonePermissionError(true);
                return;
            }
            
            const targetToDial = isVoiceCallTicket
                ? callTarget
                : Utils.addPlusToPhoneNumber(callTarget);
            const callTargetName = isVoiceCallTicket
                ? await resolveVoiceCallTargetName(callTarget, ticketAffiliationProject)
                : '';
            const calleeProjectId = (
                isVoiceCallTicket &&
                Utils.getPrefixOfId(callTarget) === Constant.ID_PREFIX.PROJECT
            ) ? callTarget : '';

            // Use existing initiateCall from CallHandler
            await initiateCall(
                {
                    phone: targetToDial,
                    name: callTargetName,
                    projectId: projectInuseDetail.id,
                    callerProjectId: projectInuseDetail.id,
                    calleeProjectId,
                    sourcePanel: 'TICKET_LIST',
                    ticketId: ticketData.id,
                    callType: isVoiceCallTicket
                        ? TelephoneConstant.CALL_TYPE.VOICE_CALL
                        : TelephoneConstant.CALL_TYPE.PHONE_CALL
                }
            );

            // Retry or follow-up: open panel if status is missed/cancelled
            handleOpenPanelTelephoneRetryOrFollowUp({
                currentTicketDetail,
                telephoneStatusItemList: ticketData.telephoneStatusItemList,
                telephoneStatusDetail: ticketData.telephoneStatusDetail,
                panelType: getPanelType(),
                panelList,
                projectInuseDetail,
                projectList,
                addNewPanel,
                reloadTicketListByPanelType
            });

        } catch (error) {
            console.error('Error calling back customer:', error);
        }
    };

    return (
        <li
            id={`${ticketDetail?.id}-ticket-item-content`}
            key={`ticket-item-content-${ticketDetail?.id}`}
            data-cy="item-ticket-frame"
            className="ticket-item-frame"
        >
            <div className="ticket-item">
                <div className="ticket-head">
                    {isQAPanel ? (
                        <>
                            <Typography variant="caption" display="block" className="ticket-sub">
                                {formatUserDateTime(ticketDetail.updatedAt, 'YYYY/MM/DD HH:mm', userDetail?.userSetting)}
                            </Typography>
                            <CopyShareLinkListItem
                                dataShareLink={ticketDetail.dataShareLink}
                                publicStatus={ticketDetail.public}
                            />
                        </>
                    ) : (
                        <>
                            <div className="ticket-head-wrap">
                                <Bookmark
                                    isViewDelete={isViewDelete}
                                    ticketKnowledge={ticketDetail}
                                    isShowEdit={true}
                                    isShowDefaultBookmark={false}
                                    panelType={Constant.PANEL_TYPE.HELPDESK_TICKET_LIST}
                                />
                                <TaggedBookmarkListName
                                    bookmarkListText={ticketDetail?.bookmarkListText}
                                    className="tagged-bookmark-list-text"
                                />
                            </div>
                            <div className="ticket-item-tools-container">
                                <CopyShareLinkListItem
                                    dataShareLink={ticketDetail.dataShareLink}
                                    publicStatus={ticketDetail.public}
                                />
                                <div className="bookmark-count">
                                    <Bookmark
                                        isViewDelete={isViewDelete}
                                        ticketKnowledge={ticketDetail}
                                        isShowEdit={false}
                                        isShowDefaultBookmark={true}
                                        tagDefaultBookmarkClassName="default-bookmark-ticket"
                                        panelType={Constant.PANEL_TYPE.HELPDESK_TICKET_LIST}
                                    />
                                    <span className="bookmark-count-number">
                                        {ticketDetail.totalPrivateBookmark >= 100
                                            ? '99+'
                                            : ticketDetail.totalPrivateBookmark}
                                    </span>
                                </div>
                            </div>
                        </>
                    )}
                    {/* <div className='ticket-star'>
                        <span className='item-star'><img src="/assets/image/icon-star.svg" alt="" /></span>
                        <span className='item-number'>12</span>
                    </div> */}
                </div>
                <div className="ticket-tlt-frame">
                    <div
                        className={
                            Utils.isAnonymousQAWaitingTicket(ticketDetail) ||
                            Utils.isAnonymousQARejectTicket(ticketDetail) ||
                            Utils.isAnonymousQATicketFromLiveChat(ticketDetail)
                                ? 'prj-icon no-bg'
                                : 'prj-icon'
                        }
                    >
                        {isGeneralTicket &&
                            !Utils.isAnonymousQATicket(ticketDetail) &&
                            Utils.isEmpty(ticketDetail.affiliationProjectInfo) && (
                                <img
                                    src="/assets/image/project-icon.png"
                                    alt=""
                                    className="ticket-item-prj-empty"
                                />
                            )}
                        {isGeneralTicket &&
                            !Utils.isAnonymousQATicket(ticketDetail) &&
                            !Utils.isEmpty(ticketDetail.affiliationProjectInfo) &&
                            ticketDetail.affiliationProjectInfo?.image !== '' && (
                                <img
                                    src={ticketDetail.affiliationProjectInfo?.image}
                                    alt=""
                                    className="ticket-item-prj-empty"
                                />
                            )}
                        {isGeneralTicket &&
                            !Utils.isAnonymousQATicket(ticketDetail) &&
                            !Utils.isEmpty(ticketDetail.affiliationProjectInfo) &&
                            ticketDetail.affiliationProjectInfo?.image === '' && (
                                <>{ticketDetail.affiliationProjectInfo?.shortName}</>
                            )}

                        {/* AnonymousQA waiting or reject or from live chat*/}
                        {(Utils.isAnonymousQAWaitingTicket(ticketDetail) ||
                            Utils.isAnonymousQARejectTicket(ticketDetail) ||
                            Utils.isAnonymousQATicketFromLiveChat(ticketDetail)) && (
                            <img
                                src="/assets/image/anonymous-qa-avatar.svg"
                                alt="Anonymous avatar"
                            />
                        )}
                        {Utils.isAnonymousQAApproveTicket(ticketDetail) &&
                            ticketDetail.affiliationProjectInfo?.image !== '' && (
                                <img
                                    src={ticketDetail.affiliationProjectInfo?.image}
                                    alt=""
                                    className="ticket-item-prj-empty"
                                />
                            )}
                        {Utils.isAnonymousQAApproveTicket(ticketDetail) &&
                            ticketDetail.affiliationProjectInfo?.image === '' && (
                                <>{ticketDetail.affiliationProjectInfo?.shortName}</>
                            )}

                        {isTicketTask && (
                            <img src="/assets/image/icon-task-ticket.svg" alt="Ticket task" />
                        )}

                        {/* Email ticket send by desk */}
                        {isEmailTicket &&
                            ticketDetail.affiliationProject === ticketDetail.projectOrigin && (
                                <img
                                    src="/assets/image/icon-email-ticket-desk-send.svg"
                                    alt="Ticket email"
                                />
                            )}
                        {/* Email ticket send by customer */}
                        {isEmailTicket &&
                            ticketDetail.affiliationProject !== ticketDetail.projectOrigin && (
                                <img
                                    src="/assets/image/icon-email-ticket-desk-receive.svg"
                                    alt="Ticket email"
                                />
                            )}
                        {/* Telephone ticket - based on call mode (incoming/outgoing/training) */}
                        {isTelephoneTicket && (
                            <img
                                src={getTelephoneTicketIcon(metaData, callDirection, projectInuseDetail, userDetail)}
                                alt="Telephone ticket"
                                className="ticket-item-prj-empty"
                            />
                        )}
                    </div>
                    <div className="ticket-info">
                        <div
                            className="ticket-info-left ticket-info-common"
                            onClick={event => openTicketDetailPanel()}
                        >
                            <SDeskTooltip
                                value={onDemandTicketTitle}
                                className="titleDisplay"
                                isOverFlowTooltip={false}
                            />

                            {renderTicketAffiliationProject()}
                        </div>
                        <div className="ticket-info-right ticket-info-common">
                            {!Utils.isAnonymousQAWaitingOrEndLiveChatTicket(ticketDetail) &&
                                !Utils.isAnonymousQALiveChatDeleted(ticketDetail) && (
                                    <>
                                        <div className="unallocated custom-unallocated">
                                            <DetailTicketListStatus
                                                API={API}
                                                isHelpdeskListTicket={isHelpdeskListTicket}
                                                isCustomerListTicket={isCustomerListTicket}
                                                item={ticketDetail}
                                                selectedTicket={selectedTicket}
                                                setSelectedTicket={setSelectedTicket}
                                                setIsLoading={setIsLoading}
                                                userDetail={userDetail}
                                                setConfirmForceEditTicket={
                                                    setConfirmForceEditTicket
                                                }
                                                panelList={panelList}
                                                setPanelList={setPanelList}
                                                triggerReload={setTriggerSearch}
                                                isDeletedCorporationOrigin={
                                                    isDeletedCorporationOrigin
                                                }
                                                ticketListType={ticketListType}
                                                setIsOpenModalReloadPage={setIsOpenModalReloadPage}
                                                ticketList={ticketList}
                                                setTicketList={setTicketList}
                                                projectInuseDetail={projectInuseDetail}
                                                corporationDetail={corporationDetail}
                                            />
                                        </div>

                                        {/* Assignee */}
                                        {isQAPanel ? (
                                            <DetailTicketListAssignee
                                                {...props}
                                                API={API}
                                                isHelpdeskListTicket={isHelpdeskListTicket}
                                                isCustomerListTicket={isCustomerListTicket}
                                                ticket={ticketDetail}
                                                ticketListType={ticketListType}
                                                userDetail={userDetail}
                                                selectedTicket={selectedTicket}
                                                setSelectedTicket={setSelectedTicket}
                                                projectUserList={projectUserList}
                                                setIsLoading={setIsLoading}
                                                setConfirmForceEditTicket={
                                                    setConfirmForceEditTicket
                                                }
                                                panelList={panelList}
                                                setPanelList={setPanelList}
                                                triggerReload={setTriggerSearch}
                                                isDeletedCorporationOrigin={
                                                    isDeletedCorporationOrigin
                                                }
                                                setIsOpenModalReloadPage={setIsOpenModalReloadPage}
                                                corporationDetail={corporationDetail}
                                                projectInuseDetail={projectInuseDetail}
                                            />
                                        ) : (
                                            <div className="ticket-date-assignee-wrap">
                                                {!isAnonymousTicket && (
                                                    <Typography
                                                        variant="caption"
                                                        display="block"
                                                        className="ticket-sub"
                                                    >
                                                        {tr('更新日：')}
                                                        {formatUserDateTime(ticketDetail.updatedAt, 'YYYY/MM/DD HH:mm', userDetail?.userSetting)}
                                                    </Typography>
                                                )}
                                                <DetailTicketListAssignee
                                                    {...props}
                                                    API={API}
                                                    isHelpdeskListTicket={isHelpdeskListTicket}
                                                    isCustomerListTicket={isCustomerListTicket}
                                                    ticket={ticketDetail}
                                                    ticketListType={ticketListType}
                                                    userDetail={userDetail}
                                                    selectedTicket={selectedTicket}
                                                    setSelectedTicket={setSelectedTicket}
                                                    projectUserList={projectUserList}
                                                    setIsLoading={setIsLoading}
                                                    setConfirmForceEditTicket={
                                                        setConfirmForceEditTicket
                                                    }
                                                    panelList={panelList}
                                                    setPanelList={setPanelList}
                                                    triggerReload={setTriggerSearch}
                                                    isDeletedCorporationOrigin={
                                                        isDeletedCorporationOrigin
                                                    }
                                                    setIsOpenModalReloadPage={
                                                        setIsOpenModalReloadPage
                                                    }
                                                    corporationDetail={corporationDetail}
                                                    projectInuseDetail={projectInuseDetail}
                                                />
                                            </div>
                                        )}
                                    </>
                                )}

                            {isAnonymousTicket && renderButtonAnonymous()}
                            {isAnonymousTicket && !isQAPanel && (
                                <Typography
                                    variant="caption"
                                    display="block"
                                    className="ticket-sub"
                                >
                                    {tr('更新日：')}
                                    {formatUserDateTime(ticketDetail.updatedAt, 'YYYY/MM/DD HH:mm', userDetail?.userSetting)}
                                </Typography>
                            )}
                        </div>
                    </div>
                </div>

                {isShowLastMessage() && (
                    <div className="ticket-last-message-wrapper">
                        <DetailTicketListLastMessage
                            ticket={ticketDetail}
                            API={API}
                            setIsLoading={setIsLoading}
                            panelId={panelId}
                            getTicketListType={getTicketListType}
                            ticketListType={ticketListType}
                            panelType={panelType}
                            viewSelectedId={props?.viewSelectedId}
                        />
                        {/* Call-back button for telephone tickets - hiển thị ngang hàng với last message */}
                        {shouldShowCallBackButton && !isViewDelete && (
                            <Tooltip title={trI18n('CALL_BACK')} placement="top">
                                <IconButton
                                    className="call-back-icon-button"
                                    onClick={e => handleCallBackCustomer(e, ticketDetail)}
                                    size="small"
                                    disabled={isDisableCallBackButton(ticketDetail?.metaData, voiceStatus)}
                                >
                                    <img
                                        src="/assets/image/telephone-callback.svg"
                                        alt=""
                                        className="call-back-icon"
                                    />
                                </IconButton>
                            </Tooltip>
                        )}
                    </div>
                )}

                {!isShowLastMessage() && shouldShowCallBackButton && !isViewDelete && (
                    <div className="ticket-callback-no-message">
                        <Tooltip title={trI18n('CALL_BACK')} placement="top">
                            <IconButton
                                className="call-back-icon-button"
                                onClick={e => handleCallBackCustomer(e, ticketDetail)}
                                size="small"
                                disabled={isDisableCallBackButton(ticketDetail?.metaData, voiceStatus)}
                            >
                                <img
                                    src="/assets/image/telephone-callback.svg"
                                    alt=""
                                    className="call-back-icon"
                                />
                            </IconButton>
                        </Tooltip>
                    </div>
                )}

                {isDisplayTicketThumbnail(ticketDetail) && (
                    <AttachThumbnailList
                        ticketDetail={ticketDetail}
                        panelType={panelType}
                        viewKey={props.viewSelectedId}
                        projectInuseDetail={projectInuseDetail}
                    />
                )}
            </div>
            <ConfirmDialog
                isOpen={isShowDialogDeleteTicketFromLiveChat}
                msgConfirm={trI18n('MSG-CM-CONFIRM-DELETE-CONTENT-ON-TICKET-LIST')}
                closeCallBack={() => setIsShowDialogDeleteTicketFromLiveChat(false)}
                okCallBack={() =>
                    handleDeleteCompleteTicketLiveChat(
                        API,
                        setIsLoading,
                        ticketDetail,
                        enqueueSnackbar,
                        setCorporationDetail,
                        closePanelTab,
                        corporationDetail,
                        panelId,
                        ticketListType,
                        panelType,
                        tabId,
                        setTriggerSearch,
                        panelList,
                        setIsShowDialogDeleteTicketFromLiveChat,
                        reloadTicketListByPanelType,
                        setIsOpenModalReloadPage,
                        projectInuseDetail?.id,
                        projectDetails
                    )
                }
                textClose={trI18n('CM-BUTTON-CANCEL')}
                textSubmit={trI18n('CM-BUTTON-OK')}
            />
            {/* Error modal for telephone agent permission */}
            <DataChangePleaseReloadModal
                isOpen={showTelephonePermissionError}
                setIsOpen={setShowTelephonePermissionError}
                content={telephoneErrorContent}
            />
        </li>
    );
}
